<template>
  <div class="page">
    <div v-if="left"
         class="left">
      <h1 v-if="left.type === 'text' && left.text"
          class="">{{ left.text }}</h1>
      <img v-if="left.type === 'image' && left.src"
           :src="left.src"
           :alt="left.src" />
      <component :is="left.componentName"
                 v-if="left.type === 'dynamic' && left.componentName" />
    </div>
    <div class="center">
      <div v-if="header"
           class="header">
        <h1 v-if="header.type === 'text' && header.text"
            class="">{{ header.text }}</h1>
        <img v-if="header.type === 'image' && header.src"
             :src="header.src"
             :alt="header.src" />
        <component :is="header.componentName"
                   v-if="header.type === 'dynamic' && header.componentName" />
        <template v-if="header.type === 'component' && header.component">
          {{ header.component }}
        </template>
      </div>
      <div v-if="title"
           class="title">
        <h1>{{ title }}</h1>
      </div>
      <div class="body">
        <slot></slot>
      </div>
    </div>
    <div v-if="right"
         class="right">
      <h1 v-if="right.type === 'text' && right.text"
          class="">{{ right.text }}</h1>
      <img v-if="right.type === 'image' && right.src"
           :src="right.src"
           :alt="right.src" />
      <component :is="right.componentName"
                 v-if="right.type === 'dynamic' && right.componentName" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useLoginStore } from '../DefaultLoginPagePlugin'

const store = useLoginStore()
const header = store.$state.header
const left = store.$state.left
const right = store.$state.right

defineProps({
  // eslint-disable-next-line vue/require-default-prop
  title: String
})

</script>

<style lang="less" scoped>
@import '@/styles/default.less';

.page {
  height: 100%;
  width: 100%;
  display: flex;
  background-color: #F5F5F5;
  justify-content: center;

  .left {
    flex: 1;
    display: flex;
  }

  .center {
    width: 700px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .header {
      width: 100%;
      display: flex;
      justify-content: center;

      h1 {
        color: @primary-color;
        font-weight: bold;
        font-size: xxx-large;
        margin: 0;
      }

      img {
        height: 16vh;
      }
    }

    .title {
      width: 100%;
      margin-top: 24px;
      margin-bottom: 24px;

      h1 {
        width: 96px;
        line-height: 40px;
        font-size: 16px;
        color: @primary-color;
        text-align: center;
        border-bottom: 2px @primary-color solid;
        margin: 0;
      }
    }

    .body {
      width: 100%;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .right {
    flex: 1;
    display: flex;
  }
}
</style>
